import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./auth-provider";

export const Authenticated = ({ children }: { children: JSX.Element }) => {
  const user = useContext(AuthContext);

  if (!!user && user?.emailVerified) {
    return children;
  } else {
    return <Navigate to="/login" />;
  }
};
